import { ActionToButton } from 'components/Button';
import { useChain } from 'contexts';
import React from 'react';

export type Props = {
  icon?: React.ElementType;
  actionTo?: string;
  actionTitle?: string;
  styleSlug?: string;
};

const SectionHeader: React.FC<Props> = ({
  icon: Icon,
  actionTo,
  actionTitle,
  styleSlug: propStyleSlug,
  children,
}) => {
  const { styleSlug: chainStyleSlug } = useChain();
  const styleSlug = propStyleSlug || chainStyleSlug;
  return (
    <div className="mb-5">
      <div className="flex items-center justify-between pb-4">
        <h2
          className={`flex items-center text-22 text-${styleSlug}-dark dark:text-${styleSlug}-light uppercase tracking-widest`}
        >
          {Icon && <Icon className="w-5 h-5 mr-4 -mt-1" />}
          {children}
        </h2>
        {!!actionTo && !!actionTitle && (
          <ActionToButton actionTo={actionTo} actionTitle={actionTitle} styleSlug={styleSlug} />
        )}
      </div>
      <div
        className={`bg-sand-primary bg-gradient-to-l dark:from-${styleSlug}-light dark:to-${styleSlug}-primary`}
        style={{ height: 2 }}
      />
    </div>
  );
};

export default SectionHeader;
